import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Upload as UploadAntd,
  Image,
  DatePicker,
  Space,
  Dropdown,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  DownloadOutlined,
  EditOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import { DownloadExcel } from "../components/ExcelFile";
import moment from "moment";
import apiPath from "../constants/apiPath";
import { downloadReportFile } from "../helper/downloadHelper";
import {
  ExclamationCircleOutlined,
  FilterFilled,
  UploadOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { AuthContext } from "../context/AuthContext";
import { uploadViaBackend } from "../helper/uploadViaBackend";
import PhoneinputField from "../components/PhoneInputField";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import MultipleImageUpload from "../components/MultipleImageUpload";
import notfound from "../assets/images/not_found.png";

import { Select } from "antd";
import { ArrowDown } from "lucide-react";
const { Option } = Select;
const answerTypes = [
  { label: "Free Text", value: "text" },
  { label: "Select from predefined values", value: "select" },
];
const { RangePicker } = DatePicker;

const Search = Input.Search;

// S3 Configuration - Use consistent endpoint
const s3Config = {
  region: "us-east-1",
  // Use consistent domain - change this to your preferred domain
  endpoint: "https://s3-noi.aces3.ai",
  forcePathStyle: true, // This ensures path-style URLs (domain/bucket/key)
};

// Helper function to normalize URLs across different S3 endpoints
const normalizeS3Url = (url) => {
  if (!url) return url;

  // List of all possible S3 endpoints that might appear
  const endpointsToNormalize = [
    's3.amplidata.com',
    's3-noi.aces3.ai',
    's3.amazonaws.com',
    'api-ap-south-mum-1.openstack.acecloudhosting.com:8080'
  ];

  let normalizedUrl = url.trim();

  endpointsToNormalize.forEach((endpoint) => {
    if (normalizedUrl.includes(endpoint)) {
      const urlParts = normalizedUrl.split(endpoint);
      if (urlParts[1]) {
        normalizedUrl = `${s3Config.endpoint}${urlParts[1]}`;
      }
    }
  });

  // Remove invalid explicit port 80 on HTTPS URLs
  if (normalizedUrl.startsWith("https://") && normalizedUrl.includes(":80/")) {
    normalizedUrl = normalizedUrl.replace(":80/", "/");
  }

  return normalizedUrl;
};

// Helper function to construct consistent S3 URL
const constructS3Url = (bucketName, key) => {
  return `${s3Config.endpoint}/${bucketName}/${key}`;
};

let baseURL = "/admin/report";

function Report({ type }) {
  const { userPermission, userProfile } = useContext(AuthContext) || {
    userPermission: [],
  };
  const isAdmin = userProfile?.type || "";
  let permissionObject = {
    add: true,
    edit: true,
    delete: true,
  };
  
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [file, setFile] = useState([]);
  const [certificateModalVisible, setCertificateModalVisible] = useState(false);
  const [certificateCP, setCertificateCP] = useState(null);
  const [image, setImage] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingReport, setEditingReport] = useState(null);
  const [wordFile, setWordFile] = useState(null);
  // Broken report modal state
  const [brokenModalVisible, setBrokenModalVisible] = useState(false);
  const [brokenRecord, setBrokenRecord] = useState(null);
  // Only PDF is required for report upload
  const [brokenUploadedFiles, setBrokenUploadedFiles] = useState({
    pdf: null,
    pdf2: null,
  });
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const BrokenPdfFileTypes = ["application/pdf"];

  const [exportLoading, setExportLoading] = useState(false);

  const handleExport = () => {
    setExportLoading(true);
    request({
      url: `${baseURL}/export`,
      method: "GET",
      onSuccess: (data) => {
        setExportLoading(false);
        if (data?.data?.list) {
          DownloadExcel(data.data.list, "Reports");
          ShowToast("Reports exported successfully!", Severty.SUCCESS);
        } else {
          ShowToast("No data to export", Severty.ERROR);
        }
      },
      onError: (error) => {
        setExportLoading(false);
        console.error(error);
        ShowToast(error?.response?.data?.message || "Failed to export reports", Severty.ERROR);
      },
    });
  };

  const columns = [
    {
      title: "TEAM NAME / LEADER NAME",
      key: "team_or_leader",
      render: (_, record) => {
        const name = record?.name;
        const userName = record?.userName;
        return <div>{name || userName || "-"}</div>;
      },
    },
    {
      title: "Requester Name",
      dataIndex: "requester",
      key: "requester",
      render: (_, record) => {
        return record?.requester?.name || "-";
      },
    },
    {
      title: "Report",
      dataIndex: "reportType",
      key: "reportType",
    },
    {
      title: "Generated Date",
      key: "dateGenerated",
      dataIndex: "dateGenerated",
      render: (_, { dateGenerated }) => {
        return new Date(dateGenerated).toLocaleDateString();
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        // Build dropdown items dynamically based on available report formats
        const dropdownItems = [];

        // Helper function to get file extension from URL
        const getFileExtension = (url) => {
          if (!url) return null;
          const extension = url.split(".").pop().toLowerCase();
          return extension;
        };

        // Normalize URLs in record to ensure consistency
        if (record?.report?.pdf) {
          record.report.pdf = normalizeS3Url(record.report.pdf);
        }
        if (record?.report?.pdf2) {
          record.report.pdf2 = normalizeS3Url(record.report.pdf2);
        }
        if (record?.report?.ppt) {
          record.report.ppt = normalizeS3Url(record.report.ppt);
        }
        if (record?.report?.docx) {
          record.report.docx = normalizeS3Url(record.report.docx);
        }

        // Check each report format and add to dropdown if URL exists and is not empty
        if (record?.report?.pdf && record.report.pdf.trim() !== "") {
          const ext = getFileExtension(record.report.pdf);
          const isFollowup =
            record?.reportType === "FollowUpTeamReports" ||
            record?.reportType === "FollowUpLeaderReports";
          
          dropdownItems.push({
            key: "pdf",
            label: isFollowup ? "PDF 1" : "PDF",
            // No filename passed: the server names it from the stored file (the exact
            // saved name, matching the email attachment). admin's list has no reportName.
            onClick: () => downloadReportFile(record._id, "pdf"),
          });

          if (isFollowup && record?.report?.pdf2 && record.report.pdf2.trim() !== "") {
            const ext2 = getFileExtension(record.report.pdf2);
            dropdownItems.push({
              key: "pdf2",
              label: "PDF 2",
              onClick: () => downloadReportFile(record._id, "pdf2"),
            });
          }
        }

        if (record?.report?.ppt && record.report.ppt.trim() !== "") {
          const ext = getFileExtension(record.report.ppt);
          const label =
            ext === "ppt" || ext === "pptx"
              ? "PPT"
              : ext === "pdf"
                ? "PDF"
                : ext === "docx"
                  ? "Word"
                  : "PPT";
          dropdownItems.push({
            key: "ppt",
            label: label,
            onClick: () => downloadReportFile(record._id, "ppt"),
          });
        }

        if (record?.report?.docx && record.report.docx.trim() !== "") {
          const ext = getFileExtension(record.report.docx);
          const label =
            ext === "docx"
              ? "Word"
              : ext === "pdf"
                ? "PDF"
                : ext === "ppt" || ext === "pptx"
                  ? "PPT"
                  : "Word";
          dropdownItems.push({
            key: "docx",
            label: label,
            onClick: () => downloadReportFile(record._id, "docx"),
          });
        }

        return (
          <Space size="large" >
            {dropdownItems.length > 0 ? (
              <Dropdown
                menu={{ items: dropdownItems }}
                getPopupContainer={(triggerNode) =>
                  triggerNode.closest(".ant-table-wrapper") || document.body
                }
              >
                <Button type="primary" icon={<ArrowDown />}>
                  REPORT
                </Button>
              </Dropdown>
            ) : (
              <Tooltip title="Please Upload The Report">
                <Button
                  type="primary"
                  danger
                  icon={<ExclamationCircleOutlined />}
                  onClick={() => {
                    setBrokenRecord(record);
                    setBrokenUploadedFiles({ pdf: null });
                    setBrokenModalVisible(true);
                  }}
                >
                  Upload Report
                </Button>
              </Tooltip>
            )}
            <Button
              danger
              title="Delete"
              onClick={() => {
                Modal.confirm({
                  content: "Are you sure you want to delete this Report?",
                  icon: <ExclamationCircleOutlined />,
                  okText: "Yes",
                  cancelText: "No",
                  onOk: () => deleteAccount(record),
                });
              }}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </Space>
        );
      },
    },
  ];
  
  useEffect(() => {
    if (certificateModalVisible && certificateCP?.certifications) {
      setImage(normalizeS3Url(certificateCP.certifications));
    }
  }, [certificateModalVisible, certificateCP]);
  
  // Updated uploadFileToS3 function with consistent URL handling
  const uploadFileToS3 = async (file, bucketName, folderPath = "") => {
    // Uploads go through the backend (no S3 keys in the browser).
    return await uploadViaBackend(file, folderPath || "realState/admin");
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location, // Now using consistent URL
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
      ShowToast("Failed to upload file", Severty.ERROR);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-customer/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    request({
      url: `${baseURL}/list?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        // Normalize all report URLs in the response
        if (data?.data?.list?.docs) {
          data.data.list.docs.forEach(record => {
            if (record?.report) {
              if (record.report.pdf) record.report.pdf = normalizeS3Url(record.report.pdf);
              if (record.report.pdf2) record.report.pdf2 = normalizeS3Url(record.report.pdf2);
              if (record.report.ppt) record.report.ppt = normalizeS3Url(record.report.ppt);
              if (record.report.docx) record.report.docx = normalizeS3Url(record.report.docx);
            }
          });
        }
        
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const handleImage = (data) => {
    const url = data?.[0]?.url || "";
    setImage(normalizeS3Url(url));
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  const handleCertificationSubmit = (values) => {
    const payload = { image: image };

    request({
      url: `${baseURL}/certifications/${values}`,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast("Certification submitted successfully!", Severty.SUCCESS);
        fetchData(pagination);
      },
    });

    setImage(null);
  };

  // Download PDF report
  const downloadPDF = async (record) => {
    try {
      const response = await fetch(
        `${apiPath.baseURL}/admin/report/download-pdf/${record._id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/pdf",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download PDF");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${record.name}_report.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      ShowToast("PDF downloaded successfully!", Severty.SUCCESS);
    } catch (error) {
      console.error("Error downloading PDF:", error);
      ShowToast("Failed to download PDF", Severty.ERROR);
    }
  };

  // Download Word report
  const downloadWord = async (record) => {
    try {
      const response = await fetch(
        `${apiPath.baseURL}/admin/report/download-word/${record._id}`,
        {
          method: "GET",
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to download Word document");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${record.name}_report.docx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      ShowToast("Word document downloaded successfully!", Severty.SUCCESS);
    } catch (error) {
      console.error("Error downloading Word document:", error);
      ShowToast("Failed to download Word document", Severty.ERROR);
    }
  };

  const PDF_FILE_TYPES = ["pdf"];
  const PPT_FILE_TYPES = ["ppt", "pptx"];
  const DOCX_FILE_TYPES = ["doc", "docx"];

  // Open edit modal for Word file
  const openEditModal = (record) => {
    setEditingReport(record);
    setEditModalVisible(true);
  };

  // Handle Word file upload for editing
  const handleWordFileUpload = (file) => {
    setWordFile(file);
    return false;
  };

  // Submit edited Word file
  const submitEditedWordFile = async () => {
    if (!wordFile || !editingReport) return;

    try {
      const formData = new FormData();
      formData.append("wordFile", wordFile);

      const response = await fetch(
        `${apiPath.baseURL}/admin/report/update-word/${editingReport._id}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update Word file");
      }

      ShowToast("Word file updated successfully!", Severty.SUCCESS);
      setEditModalVisible(false);
      setWordFile(null);
      setEditingReport(null);
      fetchData(pagination);
    } catch (error) {
      console.error("Error updating Word file:", error);
      ShowToast("Failed to update Word file", Severty.ERROR);
    }
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Report Manager"
              extra={
                <>
                  <Search
                    size="large"
                    placeholder="Search by Name"
                    onChange={onSearch}
                    title="Search by Name"
                    value={searchText}
                    onPressEnter={onSearch}
                  />
                  <Button
                    type="primary"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                    loading={exportLoading}
                  >
                    Export Excel
                  </Button>
                </>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {visible && (
        <AddForm
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
      {certificateModalVisible && (
        <Modal
          open={certificateModalVisible}
          title={
            certificateCP.certifications
              ? "Edit CP Certificate"
              : "Create CP Certificate"
          }
          onCancel={() => setCertificateModalVisible(false)}
          footer={null}
        >
          <p>
            Certificate management for:{" "}
            <b>{certificateCP?.name || certificateCP?.userName}</b>
          </p>

          <SingleImageUpload
            value={image}
            fileType={FileType}
            imageType={"Profile"}
            btnName={" Logo"}
            onChange={(data) => handleImage(data)}
            isDimension={false}
          />

          <p className="img-size-details">
            ** Certificate should be in (.png, .jpeg, .jpg .pdf ) format and up
            to 5 MB **
          </p>

          {image && (
            <div className="mt-2 add-img-product mb-4">
              {image.endsWith(".pdf") ? (
                <a href={image} target="_blank" rel="noopener noreferrer">
                  View PDF
                </a>
              ) : (
                <Image width={120} src={image} />
              )}
            </div>
          )}

          <Button
            onClick={() => {
              handleCertificationSubmit(certificateCP?._id);
              setCertificateModalVisible(false);
            }}
          >
            Submit
          </Button>
        </Modal>
      )}

      {/* Report Upload Modal – PDF only with consistent URL handling */}
      <Modal
        open={brokenModalVisible}
        title={
          brokenRecord?.reportType === "FollowUpTeamReports" ||
          brokenRecord?.reportType === "FollowUpLeaderReports"
            ? "Attach Reports (2 PDFs)"
            : "Attach Report (PDF)"
        }
        onCancel={() => {
          setBrokenModalVisible(false);
          setBrokenRecord(null);
          setBrokenUploadedFiles({ pdf: null, pdf2: null });
        }}
        footer={null}
        width={600}
      >
        <p>
          {brokenRecord?.reportType === "FollowUpTeamReports" ||
          brokenRecord?.reportType === "FollowUpLeaderReports"
            ? "Please upload the reports as PDF files."
            : "Please upload the report as PDF."}
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <div>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>
              {brokenRecord?.reportType === "FollowUpTeamReports" ||
              brokenRecord?.reportType === "FollowUpLeaderReports"
                ? "PDF File 1"
                : "PDF File"}
            </div>
            <SingleImageUpload
              value={brokenUploadedFiles?.pdf?.file || null}
              fileType={BrokenPdfFileTypes}
              imageType="broken_report_pdf"
              btnName=" PDF"
              onChange={async (data) => {
                const fileData = data?.[0] || null;
                
                // If file was uploaded, ensure URL is normalized
                if (fileData && fileData.url) {
                  fileData.url = normalizeS3Url(fileData.url);
                }
                
                setBrokenUploadedFiles((prev) => ({
                  ...prev,
                  pdf: { file: fileData, type: "pdf" },
                }));
              }}
              isDimension={false}
            />
          </div>

          {(brokenRecord?.reportType === "FollowUpTeamReports" ||
            brokenRecord?.reportType === "FollowUpLeaderReports") && (
            <div>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>PDF File 2</div>
              <SingleImageUpload
                value={brokenUploadedFiles?.pdf2?.file || null}
                fileType={BrokenPdfFileTypes}
                imageType="broken_report_pdf2"
                btnName=" PDF 2"
                onChange={async (data) => {
                  const fileData = data?.[0] || null;
                  
                  // If file was uploaded, ensure URL is normalized
                  if (fileData && fileData.url) {
                    fileData.url = normalizeS3Url(fileData.url);
                  }
                  
                  setBrokenUploadedFiles((prev) => ({
                    ...prev,
                    pdf2: { file: fileData, type: "pdf2" },
                  }));
                }}
                isDimension={false}
              />
            </div>
          )}
        </div>

        <div style={{ marginTop: 20, textAlign: "right" }}>
          <Button
            onClick={() => {
              setBrokenModalVisible(false);
              setBrokenRecord(null);
              setBrokenUploadedFiles({ pdf: null, pdf2: null });
            }}
            style={{ marginRight: 8 }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            onClick={() => {
              if (!brokenRecord) {
                ShowToast("No report selected", Severty.ERROR);
                return;
              }
              const hasPdf = brokenUploadedFiles?.pdf?.file?.url;
              const needTwoPdfs =
                brokenRecord?.reportType === "FollowUpTeamReports" ||
                brokenRecord?.reportType === "FollowUpLeaderReports";
              const hasPdf2 = brokenUploadedFiles?.pdf2?.file?.url;

              if (!hasPdf) {
                ShowToast("Please upload PDF file", Severty.ERROR);
                return;
              }

              if (needTwoPdfs && !hasPdf2) {
                ShowToast("Please upload the second PDF file", Severty.ERROR);
                return;
              }

              // Normalize the PDF URLs before sending
              const normalizedPdfUrl = normalizeS3Url(brokenUploadedFiles?.pdf?.file?.url || "");
              const normalizedPdf2Url = needTwoPdfs
                ? normalizeS3Url(brokenUploadedFiles?.pdf2?.file?.url || "")
                : "";
              
              const payload = {
                pdf: normalizedPdfUrl,
                pdf2: normalizedPdf2Url,
                ppt: "",
                docx: "",
              };

              request({
                url: `${baseURL}/attach-files/${brokenRecord._id}`,
                method: "PUT",
                data: payload,
                onSuccess: () => {
                  ShowToast("Report attached successfully", Severty.SUCCESS);
                  setBrokenModalVisible(false);
                  setBrokenRecord(null);
                  setBrokenUploadedFiles({ pdf: null, pdf2: null });
                  fetchData(pagination);
                },
                onError: (err) => {
                  ShowToast(
                    err?.response?.data?.message || "Failed to attach files",
                    Severty.ERROR
                  );
                },
              });
            }}
          >
            Submit
          </Button>
        </div>
      </Modal>
    </>
  );
}

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [reportTypes, setReportTypes] = useState([]);

  // Set available report types
  useEffect(() => {
    setReportTypes([
      "TPS for Team",
      "TPS for Leader",
      "TPS Foundations",
      "Follow Up TPS for Team",
      "Follow Up TPS for Leader",
      "Follow up TPS Foundations",
    ]);
  }, []);

  // Set form fields if editing existing data
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        name: data.name,
        report: data.report,
        dateGenerated: data.dateGenerated ? moment(data.dateGenerated) : null,
        requester: data.requester,
      });
    } else {
      form.resetFields();
    }
  }, [data]);

  const onFinish = (values) => {
    const payload = {
      name: values.name,
      report: values.report,
      dateGenerated: values.dateGenerated?.toISOString(),
      requester: values.requester,
    };

    request({
      url: data ? `/admin/report/edit/${data._id}` : `/admin/report/add`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: () => {
        ShowToast("Report saved successfully", Severty.SUCCESS);
        hide();
        refresh?.();
      },
      onError: (err) => {
        ShowToast(
          err?.response?.data?.message || "Failed to save Report",
          Severty.ERROR
        );
      },
    });
  };

  return (
    <Modal
      open={show}
      onCancel={hide}
      title={data ? "Edit Report" : "Add New Report"}
      okButtonProps={{ form: "add-survey-form", htmlType: "submit" }}
      footer={null}
    >
      <Form
        layout="vertical"
        form={form}
        id="add-survey-form"
        onFinish={onFinish}
      >
        <Form.Item
          label="Name of Team"
          name="name"
          rules={[{ required: true, message: "Team name is required" }]}
        >
          <Input placeholder="Enter name of the team" />
        </Form.Item>

        <Form.Item
          label="Type of Report"
          name="report"
          rules={[{ required: true, message: "Please select a report type" }]}
        >
          <Select placeholder="Select report type">
            {reportTypes.map((report) => (
              <Option key={report} value={report}>
                {report}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Date Generated"
          name="dateGenerated"
          rules={[{ required: true, message: "Please select a date" }]}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Name of Requester"
          name="requester"
          rules={[
            { required: true, message: "Please select the requester type" },
          ]}
        >
          <Select placeholder="Select requester type">
            <Option value="Certified Practitioner">
              Certified Practitioner
            </Option>
            <Option value="Master Facilitator">Master Facilitator</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button htmlType="submit" type="primary" block>
            {data ? "Update Survey" : "Create Survey"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Report;